// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"7fb3230a","313":"48330657","878":"42205f4b"}[chunkId] + ".chunk.js";
};